import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { SimpleVehicle, VehicleList, VehicleListItem } from '../core/models/zonar-accounts.model';
import { environment as env, environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehiclesApiService {
  v1baseUrl = `${environment.vdofleet.baseApiUrl}/master-data-service/v1/vehicles`;

  constructor(private http: HttpClient) {}

  getList(accountId: string, page = 0): Observable<VehicleList> {
    let params = new HttpParams();
    params = params.append('accountId', accountId);
    params = params.append('size', 2000);
    params = params.append('page', page);
    params = params.append('sort', 'id,asc');
    return this.http.get<VehicleList>(this.v1baseUrl, { params });
  }

  getVehicleByVin(vin: string): Observable<VehicleListItem[]> {
    let params = new HttpParams();
    params = params.append('vin', vin);
    return this.http.get<VehicleList>(this.v1baseUrl, { params }).pipe(map(resp => resp.data));
  }

  getSimpleList(ids: string[] | number[] = []): Observable<SimpleVehicle[]> {
    let params = new HttpParams();
    params = params.append('size', 2000);
    return this.http.get<SimpleVehicle[]>(this.v1baseUrl, { params });
  }
}
